/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ProblemDetailDto } from '../models';
// @ts-ignore
import type { QuestionChangePlanDto } from '../models';
// @ts-ignore
import type { QuestionImpactDto } from '../models';
/**
 * QuestionImpactApi - axios parameter creator
 * @export
 */
export const QuestionImpactApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Nothing changes. A test is reported when a part that has enough questions in a language today would not have after the change; a survey, when one of its questions would fall out of use or lose approved wording in one of its languages. Only what the change would break is listed — a test already short stays on the list of tests as it is. For a position the pool counts the questions for every position and for it, as a person there sees the test.
         * @summary Which active tests and surveys a planned change would leave short of questions
         * @param {QuestionChangePlanDto} questionChangePlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkQuestionImpact: async (questionChangePlanDto: QuestionChangePlanDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'questionChangePlanDto' is not null or undefined
            assertParamExists('checkQuestionImpact', 'questionChangePlanDto', questionChangePlanDto)
            const localVarPath = `/api/v1/questions/impact`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(questionChangePlanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * QuestionImpactApi - functional programming interface
 * @export
 */
export const QuestionImpactApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = QuestionImpactApiAxiosParamCreator(configuration)
    return {
        /**
         * Nothing changes. A test is reported when a part that has enough questions in a language today would not have after the change; a survey, when one of its questions would fall out of use or lose approved wording in one of its languages. Only what the change would break is listed — a test already short stays on the list of tests as it is. For a position the pool counts the questions for every position and for it, as a person there sees the test.
         * @summary Which active tests and surveys a planned change would leave short of questions
         * @param {QuestionChangePlanDto} questionChangePlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkQuestionImpact(questionChangePlanDto: QuestionChangePlanDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionImpactDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkQuestionImpact(questionChangePlanDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['QuestionImpactApi.checkQuestionImpact']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * QuestionImpactApi - factory interface
 * @export
 */
export const QuestionImpactApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = QuestionImpactApiFp(configuration)
    return {
        /**
         * Nothing changes. A test is reported when a part that has enough questions in a language today would not have after the change; a survey, when one of its questions would fall out of use or lose approved wording in one of its languages. Only what the change would break is listed — a test already short stays on the list of tests as it is. For a position the pool counts the questions for every position and for it, as a person there sees the test.
         * @summary Which active tests and surveys a planned change would leave short of questions
         * @param {QuestionChangePlanDto} questionChangePlanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkQuestionImpact(questionChangePlanDto: QuestionChangePlanDto, options?: RawAxiosRequestConfig): AxiosPromise<QuestionImpactDto> {
            return localVarFp.checkQuestionImpact(questionChangePlanDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * QuestionImpactApi - interface
 * @export
 * @interface QuestionImpactApi
 */
export interface QuestionImpactApiInterface {
    /**
     * Nothing changes. A test is reported when a part that has enough questions in a language today would not have after the change; a survey, when one of its questions would fall out of use or lose approved wording in one of its languages. Only what the change would break is listed — a test already short stays on the list of tests as it is. For a position the pool counts the questions for every position and for it, as a person there sees the test.
     * @summary Which active tests and surveys a planned change would leave short of questions
     * @param {QuestionChangePlanDto} questionChangePlanDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionImpactApiInterface
     */
    checkQuestionImpact(questionChangePlanDto: QuestionChangePlanDto, options?: RawAxiosRequestConfig): AxiosPromise<QuestionImpactDto>;

}

/**
 * QuestionImpactApi - object-oriented interface
 * @export
 * @class QuestionImpactApi
 * @extends {BaseAPI}
 */
export class QuestionImpactApi extends BaseAPI implements QuestionImpactApiInterface {
    /**
     * Nothing changes. A test is reported when a part that has enough questions in a language today would not have after the change; a survey, when one of its questions would fall out of use or lose approved wording in one of its languages. Only what the change would break is listed — a test already short stays on the list of tests as it is. For a position the pool counts the questions for every position and for it, as a person there sees the test.
     * @summary Which active tests and surveys a planned change would leave short of questions
     * @param {QuestionChangePlanDto} questionChangePlanDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof QuestionImpactApi
     */
    public checkQuestionImpact(questionChangePlanDto: QuestionChangePlanDto, options?: RawAxiosRequestConfig) {
        return QuestionImpactApiFp(this.configuration).checkQuestionImpact(questionChangePlanDto, options).then((request) => request(this.axios, this.basePath));
    }
}

